/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum BITWIDTH_VALUES {
  _128 = "128",
  _256 = "256",
}
